import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { alphabeticallySort } from '../../../../utilities/helperUtility';
import Select from '../../../../components/Common/Select';
import ComponentSelect from '../ComponentSelect';
import ErrorTooltip from '../../ErrorTooltip';

export default class LocationSelect extends ComponentSelect {
  locationOptions() {
    const { blankOption, locations } = this.props;

    let options = alphabeticallySort(locations, 'name').map(({ id, name }) => ({
      label: name,
      value: id,
    }));

    if (blankOption) {
      options.unshift(blankOption);
    }
    
    return options;
  }

  render() {
    const {
      bookingToken,
      errors,
      errorMessage,
      isDisabled,
      isDisableClearable,
      label,
      selectedLocation,
      style,
      styles,
      className,
      kind,
    } = this.props;
    const locationOptions = this.locationOptions();
    if (!locationOptions.length || bookingToken) return null;
    const value = isEmpty(selectedLocation) ? null : selectedLocation.id;

    return (
      <div className="select-block text-left locations-select">
        <span className="titles" style={{ ...style }}>
          {label}
        </span>
        <div style={{ position: 'relative' }}>
          <Select
            placeholder={this.placeholder()}
            styles={styles}
            className={className}
            name={kind}
            value={value}
            options={locationOptions}
            isClearable={!isDisableClearable}
            isDisabled={isDisabled}
            allowSelectOption
            isSearchable={false}
            onChange={this.onChange}
          />
          {errors && <ErrorTooltip message={errorMessage} />}
        </div>
      </div>
    );
  }
}
